<template>
  <table class="results-table">
    <thead>
      <tr>
        <th>{{ $t('filter.blisterName') }}</th>
        <th>{{ $t('filter.width') }} × {{ $t('filter.length') }}</th>
        <th>{{ $t('filter.height') }}</th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="blister in selectedBlisters"
        :key="`${blister.name}:${blister.height}`"
        @click="select(blister)"
        :class="{active: blister === selectedBlister}"
      >
        <td>{{ blister.name }}</td>
        <td>{{ blister.width }}&#8239;×&#8239;{{ blister.length }}&#8239;mm</td>
        <td>{{ blister.height }}&#8239;mm</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    matchedBlisters: Array
  },
  data() {
    return {
      selectedBlister: null,
    }
  },
  methods: {
    select(blister) {
      this.selectedBlister = blister
      this.$emit('blister-selected', blister)
    },
  },
  computed: {
    selectedBlisters: vm =>
      vm.matchedBlisters.map(blister => ({
        ...blister
      }))
  }
}
</script>

<style lang="scss" scoped>
.results-table {
  border-collapse: collapse;
  width: 100%;

  @at-root .size-min-small & {
    width: 100%;
  }

  th {
    font-weight: inherit;
  }

  tbody tr {
    cursor: pointer;
    transition: background-color ease 150ms;

    &:hover {
      background-color: rgba(#fff, 0.1);
    }

    &.active {
      background-color: rgba(#fff, 0.2);
    }
  }

  th,
  td {
    text-align: center;
    padding: 7px 10px;
    border-bottom: 1px solid var(--weak-accent);

    @at-root .size-min-small & {
      padding: 10px 20px;
    }
  }
}
</style>
